/**
 * Toast container molecule: react-toastify's ToastContainer with the app's
 * default options, pinned to the light theme.
 */
"use client";

import { ToastContainer } from "react-toastify";

export function ThemeAwareToast() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
}
